module.exports = __webpack_public_path__ + "static/img/shareBk.d0dc963.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shareFiesta/shareBk.webp
// module id = b0T1
// module chunks = 0